import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { servicesData } from '../data/servicesData';
import { Helmet } from "react-helmet"; // Dynamic SEO ke liye

function DetailedServices() {
  const { id } = useParams();

  const selectedService = servicesData.find(s => s.id === parseInt(id));
  const otherServices = servicesData.filter(s => s.id !== parseInt(id));
  const sortedServices = selectedService ? [selectedService, ...otherServices] : servicesData;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [id]);

  return (
    <div className="bg-slate-50 min-h-screen py-16">
      {/* --- DYNAMIC SEO HELMET --- */}
      {selectedService && (
        <Helmet>
          <title>{selectedService.title} | Global Solutions by ZYGMA</title>
          <meta name="description" content={`Professional worldwide ${selectedService.title} services. ${selectedService.desc.substring(0, 150)}...`} />
          <meta name="keywords" content={`${selectedService.title}, Worldwide Digital Services, Global Agency, ZYGMA Expertise`} />
          <link rel="canonical" href={`https://zygmagrowthsolutions.com/services/${id}`} />
        </Helmet>
      )}

      <div className="max-w-5xl mx-auto px-6">
        
        <div className="text-center mb-16">
          <h1 className="text-4xl font-black text-gray-900">
            Our <span className="text-blue-600">Expertise</span>
          </h1>
          <p className="text-gray-500 mt-2 font-medium">Deep dive into our professional worldwide solutions.</p>
        </div>

        <div className="space-y-10">
          {sortedServices.map((service, index) => (
            <motion.div
              key={service.id}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`p-8 md:p-12 rounded-[3rem] shadow-xl border-2 transition-all duration-500 ${
                index === 0 
                ? 'bg-blue-600 text-white border-blue-400 ring-8 ring-blue-600/10' 
                : 'bg-white text-gray-800 border-transparent hover:border-blue-100'
              }`}
            >
              <div className="flex flex-col md:flex-row gap-10 items-center md:items-start">
                {/* Icon Container */}
                <div className={`text-6xl p-8 rounded-[2rem] shadow-inner ${
                  index === 0 ? 'bg-white/10' : 'bg-blue-50'
                }`}>
                  {service.icon}
                </div>

                {/* Text Content */}
                <div className="flex-1 text-center md:text-left">
                  {index === 0 && (
                    <span className="bg-white/20 text-[10px] font-black px-4 py-1 rounded-full mb-4 inline-block uppercase tracking-[0.2em]">
                      Featured Solution
                    </span>
                  )}
                  {/* SEO: Using H2 for each service title is excellent for hierarchy */}
                  <h2 className="text-3xl font-black mb-6 tracking-tight">{service.title}</h2>
                  <p className={`text-lg leading-relaxed mb-8 ${index === 0 ? 'text-blue-50' : 'text-gray-500'}`}>
                    {service.desc}
                  </p>
                  
                  {/* Features Grid */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div className={`p-5 rounded-2xl border ${index === 0 ? 'bg-white/10 border-white/20' : 'bg-slate-50 border-slate-100'}`}>
                      <h4 className="font-bold text-sm uppercase tracking-wider mb-1">Global Outcome</h4>
                      <p className="text-sm opacity-80 italic">Market dominance and high conversion rates internationally.</p>
                    </div>
                    <div className={`p-5 rounded-2xl border ${index === 0 ? 'bg-white/10 border-white/20' : 'bg-slate-50 border-slate-100'}`}>
                      <h4 className="font-bold text-sm uppercase tracking-wider mb-1">Standard Delivery</h4>
                      <p className="text-sm opacity-80 italic">Strategic implementation within 4-6 weeks worldwide.</p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default DetailedServices;